import { IntlShape } from 'react-intl';

export function getDocFromPathname(pathname: string, intl: IntlShape) {
  switch (pathname) {
    case 'legacy':
    case 'user_agreement':
      return {
        code: 'user_agreement',
        name: intl.formatMessage({ id: 'SUBMENU.LEGAL_TERMS' }),
      };
    case 'privacy':
    case 'privacy_policy':
      return {
        code: 'privacy_policy',
        name: intl.formatMessage({ id: 'SUBMENU.LEGAL_PRIVACY' }),
      };
    case 'shipping':
    case 'shipping_policy':
      return {
        code: 'shipping_policy',
        name: intl.formatMessage({ id: 'SUBMENU.LEGAL_SHIPPING' }),
      };
    case 'refund':
    case 'refund_policy':
      return {
        code: 'refund_policy',
        name: intl.formatMessage({ id: 'SUBMENU.LEGAL_REFUND' }),
      };

    case 'driveroffer':
    case 'driver_offer':
      return {
        code: 'driver_offer',
        name: intl.formatMessage({ id: 'AUTH.GENERAL.PRIVACY.DRIVER' }),
      };

    case 'accountdeletion':
    case 'account_deletion':
      return {
        code: 'account_deletion',
        name: intl.formatMessage({ id: 'DOC.ACCOUNT_DELETION' }),
      };

    default:
      return {
        code: 'user_agreement',
        name: intl.formatMessage({ id: 'DOC.USER_AGREEMENT' }),
      };
  }
}
